import React from "react";

// Small icon set — stroke-based, 1px lines, no fills. Linear/lucide-ish.

const Icon = ({ children, size = 14, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.4"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...rest}
  >{children}</svg>
);

export const ChevronRight = (p) => <Icon {...p}><path d="M6 3 L11 8 L6 13" /></Icon>;
export const ChevronDown  = (p) => <Icon {...p}><path d="M3 6 L8 11 L13 6" /></Icon>;
export const Close        = (p) => <Icon {...p}><path d="M4 4 L12 12 M12 4 L4 12" /></Icon>;
export const Search       = (p) => <Icon {...p}><circle cx="7" cy="7" r="4" /><path d="M10 10 L13 13" /></Icon>;
export const ExternalLink = (p) => <Icon {...p}><path d="M7 4 H4 V12 H12 V9" /><path d="M9 3 H13 V7" /><path d="M8 8 L13 3" /></Icon>;
export const Sun          = (p) => <Icon {...p}><circle cx="8" cy="8" r="2.5"/><path d="M8 2 V3.5 M8 12.5 V14 M2 8 H3.5 M12.5 8 H14 M3.7 3.7 L4.8 4.8 M11.2 11.2 L12.3 12.3 M3.7 12.3 L4.8 11.2 M11.2 4.8 L12.3 3.7"/></Icon>;
export const Moon         = (p) => <Icon {...p}><path d="M13 9.5 A5 5 0 1 1 6.5 3 A4 4 0 0 0 13 9.5 Z"/></Icon>;
export const Info         = (p) => <Icon {...p}><circle cx="8" cy="8" r="5.5" /><path d="M8 7 V11" /><path d="M8 5 V5.5" /></Icon>;
export const Logo         = (p) => <Icon {...p} size={14}><path d="M2 8 H5 L7 4 L9 12 L11 8 H14" /></Icon>;
export const GitHub       = (p) => <Icon {...p}><path d="M8 1.5 a6.5 6.5 0 0 0 -2 12.7 c0.3 0.05 0.45 -0.14 0.45 -0.3 v-1.1 c-1.85 0.4 -2.25 -0.9 -2.25 -0.9 c-0.3 -0.75 -0.7 -0.95 -0.7 -0.95 c-0.6 -0.4 0.05 -0.4 0.05 -0.4 c0.65 0.05 1 0.65 1 0.65 c0.6 1 1.55 0.7 1.9 0.55 c0.05 -0.45 0.25 -0.7 0.45 -0.85 c-1.5 -0.15 -3.05 -0.75 -3.05 -3.3 c0 -0.75 0.25 -1.35 0.7 -1.8 c-0.05 -0.2 -0.3 -0.9 0.05 -1.85 c0 0 0.55 -0.2 1.85 0.7 a6.3 6.3 0 0 1 3.35 0 c1.3 -0.9 1.85 -0.7 1.85 -0.7 c0.35 0.95 0.1 1.65 0.05 1.85 c0.45 0.45 0.7 1.05 0.7 1.8 c0 2.55 -1.55 3.15 -3.05 3.3 c0.25 0.2 0.45 0.6 0.45 1.2 v1.75 c0 0.15 0.1 0.35 0.45 0.3 A6.5 6.5 0 0 0 8 1.5 z" fill="currentColor" stroke="none"/></Icon>;

/* Category icons — abstract, never the literal product mark */
const CatProtocol = (p) => <Icon {...p}><path d="M3 8 H6 M10 8 H13" /><circle cx="8" cy="8" r="2" /></Icon>;
const CatTool     = (p) => <Icon {...p}><path d="M5 11 L11 5" /><path d="M3.5 12.5 L5 11 L4 10 L2.5 11.5 Z" /><path d="M12.5 3.5 L11 5 L12 6 L13.5 4.5 Z" /></Icon>;
const CatIncident = (p) => <Icon {...p}><path d="M8 2 L14 13 H2 Z" /><path d="M8 7 V9.5" /><circle cx="8" cy="11.5" r="0.3" fill="currentColor"/></Icon>;
const CatResearch = (p) => <Icon {...p}><circle cx="7" cy="7" r="3.5" /><path d="M9.5 9.5 L13 13" /></Icon>;
const CatAdoption = (p) => <Icon {...p}><path d="M2 12 L6 8 L9 11 L14 4" /><path d="M11 4 H14 V7" /></Icon>;
const CatVendor   = (p) => <Icon {...p}><path d="M3 6 L8 3 L13 6 V12 L8 14 L3 12 Z" /><path d="M3 6 L8 9 L13 6" /><path d="M8 9 V14" /></Icon>;

export const CATEGORY_ICONS = {
  protocol: CatProtocol,
  tool:     CatTool,
  incident: CatIncident,
  research: CatResearch,
  adoption: CatAdoption,
  vendor:   CatVendor,
};
